import { Router, NavigationEnd } from '@angular/router';
import { Injectable, NgZone } from "@angular/core";
import { filter, map, distinctUntilChanged } from 'rxjs/operators';
import posthog from "posthog-js";
import { environment } from "../../../../environments/environment";
import { UserModel } from 'src/app/core/models/user.model';


@Injectable({ providedIn: 'root' })
export class PosthogService {
  constructor(private ngZone: NgZone, private router: Router) {}

  public init(user?: UserModel): void {
    if (environment.env !== 'prod') return;

    this.ngZone.runOutsideAngular(() => {
      posthog.init(environment.posthogKey, {
        api_host: environment.posthogHost,
        debug: false,
        cross_subdomain_cookie: true,
        capture_pageview: false,
        session_recording: {
          recordConsole: true,
          recordNetwork: true,
          maskNetworkText: false,
        } as any,
      });

      if (user) {
        posthog.identify(user.firstName, {
          name: user.firstName
        });
      }
    });
  }

  public trackPageviews(router: Router): void {
    if (environment.env !== 'prod') return;

    // fire one for the initial load
    posthog.capture('$pageview', {
      $current_url: window.location.href,
      $pathname: router.url,
    });

    this.ngZone.runOutsideAngular(() => {
      router.events
        .pipe(
          filter((e): e is NavigationEnd => e instanceof NavigationEnd),
          map(e => e.urlAfterRedirects),
          distinctUntilChanged()
        )
        .subscribe(url => {
          posthog.capture('$pageview', {
            $current_url: window.location.origin + url,
            $pathname: url,
          });
        });
    });
  }

  public reset(): void {
    if (environment.env === 'prod') {
      posthog.reset();
    }
  }

  public recordCustomEvent(featureType?: string, feature?: string): void {
    posthog.capture
      (featureType,
        { feature: feature }
      );
  }
}
